<template>
  <page-layout title="게시판 목록">
    <template v-slot:content>
      <v-flex>
        <div class="board-type-layout" v-if="!isUser">
          <div class="board-type-button-layout">
          <span class="board-type-button" :class="{'isClicked': isAllType}" @click="clickBoardType('ALL')">
            전체
          </span>
          </div>
          <div class="board-type-button-layout">
          <span class="board-type-button" :class="{'isClicked': isManagerType}" @click="clickBoardType('MANAGER')">
            관리팀장용
          </span>
          </div>
        </div>
        <v-row class="boards">
          <v-col
              class="board-layout col-xl-3 col-md-4 col-sm-6 col-12"
              v-for="(item, index) in typeBoardList" :key="index"
          >
            <div class="board-title-layout">
              <span class="board-title">{{ item.categoryNm }}</span>
              <span class="see-more" @click="seeMoreCategory(item)">더보기</span>
            </div>
            <ul class="board-list"
                :class="{
        'all-notice': board_item.noticeLevel === 3,
        'type-notice': board_item.noticeLevel === 2,
        'normal-notice': board_item.noticeLevel === 1,
        'none-notice': board_item.title === ''
      }"
                v-for="(board_item, board_index) in item.boardList" :key="board_index"
                @click="showBoardDetail(item, board_item)"
            >
              <li
                  class="board"
                  :class="{
          'all': board_item.noticeLevel === 3,
          'type': board_item.noticeLevel === 2,
          'normal': board_item.noticeLevel === 1
        }"
              >
                <span>{{ overLengthText(board_item.title, boardTitleMaxLength) }}</span>
              </li>
              <li class="board">
                {{ board_item.viewCnt }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-flex>
    </template>
  </page-layout>
</template>

<script>

import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import router from "@/router";
import PageLayout from "@/common/layout/PageLayout.vue";
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "BoardMain",
  components: {PageLayout},
  mixins: [TableMixin],
  data() {
    return {
      isAllType: true,
      isManagerType: false,
      categoryList: [],
      boardList: [],
      managerBoardList: [],
      deviceWidth: 0,
      boardMaxLength: 0,
      boardTitleMaxLength: 0
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId",
      memberRole: "memberRole"
    }),
    isUser() {
      return this.memberRole === "USER";
    },
    typeBoardList() {
      if (this.isAllType) {
        return this.categoryList;
      }
      if (this.isManagerType) {
        return this.managerBoardList;
      }
      return null;
    }
  },
  mounted() {
    this.getBoardCategory();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.deviceWidth = window.innerWidth;
      this.boardMaxLength = 10;
      if (this.deviceWidth < 1264) {
        this.boardTitleMaxLength = 16;
      }
      if (this.deviceWidth >= 1264) {
        this.boardTitleMaxLength = 25;
      }
    },
    async getBoardCategory() {
      try {
        const { data } = await axiosInstance.get("/private/board/category", {
          params: {
            memberId: this.memberId,
            useYn: "Y"
          }
        });
        if (data.length < 1) {
          this.categoryList = [];
        }
        else {
          this.categoryList = data;
          await this.getBoardList(data);
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }

    },
    async getBoardList(categoryList) {
      if (categoryList.length < 1) {
        return false;
      }
      for (let i = 0; i < categoryList.length; i++) {
        try {
          await axiosInstance.get("/private/board/board-list", {
            params: {
              categoryId: categoryList[i].categoryId,
              searchNm: "",
              searchType: "ALL"
            }
          }).then((response) => {
            let resultList = this.listFiller(response.data);
            this.$set(this.categoryList[i], "boardList", resultList);
          })
        } catch (error) {
          await this.showAlert({message: `${error.response.data.message}`});
        }
      }
      if (!this.isUser) {
        this.setManagerBoardList();
      }
    },
    listFiller(list) {
      let replaceList = [...list];
      if (list.length > this.boardMaxLength) {
        return list.slice(0, this.boardMaxLength);
      } else {
        const missingCount = this.boardMaxLength - list.length; // 숫자 타입
        for (let i = 0; i < missingCount; i++) {
          replaceList.push({noticeLevel: 1, title: "", createDate: "" });
        }
        return replaceList;
      }
    },
    setManagerBoardList() {
      this.categoryList.map(item => {
        if (item.useRole !== "USER") {
          this.managerBoardList.push(item);
        }
      })
    },
    clickBoardType(type) {
      if (type === "ALL") {
        this.isAllType = true;
        this.isManagerType = false;
      }
      if (type === "MANAGER") {
        this.isAllType = false;
        this.isManagerType = true;
      }
    },
    seeMoreCategory(item) {
      sessionStorage.setItem("boardDetailList", JSON.stringify(item));
      router.push({name: "BoardTable", params: {categoryId: item.categoryId}});
    },
    showBoardDetail(item, boardItem) {
      if (boardItem.title === "") return false;
      sessionStorage.setItem("boardDetailList", JSON.stringify(item));
      sessionStorage.setItem("boardDetail", JSON.stringify(boardItem));
      router.push({name: "BoardDetail", params: {boardId: boardItem.boardId}});
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Board/BoardCommon.scss";
@import "@/assets/scss/Board/BoardMain.scss";
</style>